// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Raleway:400);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --angle {
  syntax: "<angle>";
  initial-value: 90deg;
  inherits: true;
}
@property --gradX {
  syntax: "<percentage>";
  initial-value: 50%;
  inherits: true;
}
@property --gradY {
  syntax: "<percentage>";
  initial-value: 0%;
  inherits: true;
}
:root {
  --d: 2500ms;
  --angle: 90deg;
  --gradX: 100%;
  --gradY: 50%;
  --c1: #f94c8e;
  --c2: rgba(168, 239, 255, 0.1);
}

.wrapper {
  min-width: min(40rem, 100%);
}

.inputboxcustom {
  border: 0.35rem solid;
  border-image: conic-gradient(from var(--angle), var(--c2), var(--c1) 0.1turn, var(--c1) 0.15turn, var(--c2) 0.25turn) 30;
  animation: borderRotate var(--d) linear infinite forwards;
}

.inputboxcustom:nth-child(2) {
  border-image: radial-gradient(ellipse at var(--gradX) var(--gradY), var(--c1), var(--c1) 10%, var(--c2) 40%) 30;
  animation: borderRadial var(--d) linear infinite forwards;
}

@keyframes borderRotate {
  100% {
    --angle: 520deg;
  }
}
@keyframes borderRadial {
  20% {
    --gradX: 100%;
    --gradY: 50%;
  }
  40% {
    --gradX: 100%;
    --gradY: 100%;
  }
  60% {
    --gradX: 50%;
    --gradY: 100%;
  }
  80% {
    --gradX: 0%;
    --gradY: 50%;
  }
  100% {
    --gradX: 50%;
    --gradY: 0%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/CostType/InputBox.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,oBAAA;EACA,cAAA;AAAF;AAGA;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;AADF;AAIA;EACE,sBAAA;EACA,iBAAA;EACA,cAAA;AAFF;AAKA;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACC,qBAAA;EACC,wHAAA;EAQA,yDAAA;AAVF;;AAaA;EACE,+GAAA;EAOA,yDAAA;AAhBF;;AAmBA;EACE;IACE,eAAA;EAhBF;AACF;AAmBA;EACE;IACE,aAAA;IACA,YAAA;EAjBF;EAmBA;IACE,aAAA;IACA,aAAA;EAjBF;EAmBA;IACE,YAAA;IACA,aAAA;EAjBF;EAmBA;IACE,WAAA;IACA,YAAA;EAjBF;EAmBA;IACE,YAAA;IACA,WAAA;EAjBF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Raleway:400\");\n\n@property --angle {\n  syntax: \"<angle>\";\n  initial-value: 90deg;\n  inherits: true;\n}\n\n@property --gradX {\n  syntax: \"<percentage>\";\n  initial-value: 50%;\n  inherits: true;\n}\n\n@property --gradY {\n  syntax: \"<percentage>\";\n  initial-value: 0%;\n  inherits: true;\n}\n\n:root {\n  --d: 2500ms;\n  --angle: 90deg;\n  --gradX: 100%;\n  --gradY: 50%;\n  --c1: #f94c8e;\n  --c2: rgba(168, 239, 255, 0.1);\n}\n\n.wrapper {\n  min-width: min(40rem, 100%);\n}\n\n.inputboxcustom {\n border: 0.35rem solid;\n  border-image: conic-gradient(\n      from var(--angle),\n      var(--c2),\n      var(--c1) 0.1turn,\n      var(--c1) 0.15turn,\n      var(--c2) 0.25turn\n    )\n    30;\n  animation: borderRotate var(--d) linear infinite forwards;\n}\n\n.inputboxcustom:nth-child(2) {\n  border-image: radial-gradient(\n      ellipse at var(--gradX) var(--gradY),\n      var(--c1),\n      var(--c1) 10%,\n      var(--c2) 40%\n    )\n    30;\n  animation: borderRadial var(--d) linear infinite forwards;\n}\n\n@keyframes borderRotate {\n  100% {\n    --angle: 520deg;\n  }\n}\n\n@keyframes borderRadial {\n  20% {\n    --gradX: 100%;\n    --gradY: 50%;\n  }\n  40% {\n    --gradX: 100%;\n    --gradY: 100%;\n  }\n  60% {\n    --gradX: 50%;\n    --gradY: 100%;\n  }\n  80% {\n    --gradX: 0%;\n    --gradY: 50%;\n  }\n  100% {\n    --gradX: 50%;\n    --gradY: 0%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
